/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log("Container ———————— ↓");
      // console.log(container);
      // console.log("Variant —————————— ↓");
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log("Cart ———————————— ↓");
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    // console.log("theme:cart:init");
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {
    // console.log(e);
  });
  document.addEventListener("theme:scroll:up", (e) => {
    // console.log(e);
  });
  document.addEventListener("theme:scroll:down", (e) => {
    // console.log(e);
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    // console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

class RecommendAtcBtn extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    const variantId = this.getAttribute("data-variant-id");
    if (variantId) {
      // Logic to add the recommended product to the cart
      console.log(`Adding product ${variantId} to cart`);
      // You can implement the actual add-to-cart logic here
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Product added to cart:", data);
          // Optionally, you can update the cart UI or show a success message

          document
            .querySelector(".cart__drawer input.quantity__input ")
            ?.dispatchEvent(new Event("change", { bubbles: true }));
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          // Optionally, you can show an error message to the user
        });
    }
  }
}
customElements.define("recommend-atc-btn", RecommendAtcBtn);

customElements.define(
  "flickity-slider-v2",
  class extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.mediaQuery = window.matchMedia("(max-width: 767px)");
      this.flicktySection = this.querySelector(".flickity-slider-section");
      this.flickityOptions = {
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        groupCells: "100%",
        wrapAround: false,
        adaptiveHeight: true,
      };

      this.initFlickity();
      this.setupMediaQueryListener();
    }

    initFlickity() {
      // Only initialize on mobile using CSS media query
      if (!this.mediaQuery.matches) {
        return;
      }

      // Set up responsive behavior on mobile (1 or 1.5 slides per view)
      const slides = this.querySelectorAll(".flickity-slide, .carousel-cell");
      if (slides.length > 0) {
        const onePerView = this.dataset.mobileOnePerView === "true";
        const slideWidth = (100 / (onePerView ? 1 : 1.5)).toFixed(2);
        slides.forEach((slide) => {
          slide.style.width = `${slideWidth}%`;
        });
      }

      // Initialize Flickity
      if (typeof Flickity !== "undefined" && !this.flickityInstance) {
        // Con adaptiveHeight el viewport toma la altura del slide seleccionado,
        // así que al swipear entre slides de distinto largo el carrusel (y los
        // page dots) salta. Cuando la sección pide todos los bloques del mismo
        // tamaño lo apagamos: Flickity fija la altura a la del slide más alto y
        // el carrusel queda quieto.
        const equalHeight = this.dataset.equalHeight === "true";
        this.flickityInstance = new Flickity(this.flicktySection, {
          ...this.flickityOptions,
          adaptiveHeight: !equalHeight,
        });
      }
    }

    destroyFlickity() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
    }

    setupMediaQueryListener() {
      this.mediaQuery.addEventListener("change", (e) => {
        if (e.matches) {
          // Mobile view - initialize flickity
          this.initFlickity();
        } else {
          // Desktop view - destroy flickity
          this.destroyFlickity();
        }
      });
    }
  }
);

(function () {
  const config = window.WOU_COUPON_GIFTS;
  const thresholdCfg = window.WOU_THRESHOLD_GIFT;
  const couponEnabled = !!(config && config.enabled && config.mapping);
  const thresholdEnabled = !!(
    thresholdCfg &&
    thresholdCfg.enabled &&
    thresholdCfg.variantId &&
    /^\d+$/.test(String(thresholdCfg.variantId)) &&
    thresholdCfg.amountCents > 0
  );
  if (!couponEnabled && !thresholdEnabled) return;

  // El regalo por umbral lo pone en $0 el descuento automático "Plato gratis!" de
  // Shopify, que está limitado al segmento "Clientes sin pedidos" (number_of_orders = 0).
  // A un cliente logueado que ya compró, Shopify no se lo descuenta: agregarle el regalo
  // igual le mostraría el badge REGALO en el carrito y se lo terminarían cobrando en el
  // checkout. Los invitados sí lo reciben (no están identificados como clientes con
  // pedidos), así que solo dejamos afuera a quien tiene sesión iniciada con al menos una
  // compra. Esto no toca los regalos por cupón: esos códigos aplican a todos.
  const thresholdGiftEligible =
    !thresholdEnabled ||
    !thresholdCfg.customerLoggedIn ||
    Number(thresholdCfg.customerOrdersCount || 0) === 0;

  function parseMapping(text) {
    const map = {};
    String(text).split(/[\n|]/).forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;
      const firstColon = trimmed.indexOf(":");
      if (firstColon === -1) return;
      const code = trimmed.slice(0, firstColon).trim().toUpperCase();
      const productsStr = trimmed.slice(firstColon + 1).trim();
      if (!code || !productsStr) return;
      const seen = new Set();
      const products = productsStr
        .split(",")
        .map((p) => ({ id: p.trim().split(":")[0].trim(), qty: 1 }))
        .filter((p) => {
          if (!/^\d+$/.test(p.id) || seen.has(p.id)) return false;
          seen.add(p.id);
          return true;
        });
      if (products.length) map[code] = products;
    });
    return map;
  }

  const mapping = couponEnabled ? parseMapping(config.mapping) : {};
  if (couponEnabled && !Object.keys(mapping).length && !thresholdEnabled) return;

  function getDiscountCookieCode() {
    const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!match) return null;
    let raw = match[1];
    try {
      raw = raw.replace(/\+/g, " ");
      raw = decodeURIComponent(raw);
    } catch (_) {}
    return raw.trim().toUpperCase();
  }

  let syncing = false;
  let lastSyncedAt = 0;
  let pendingTimer = null;

  async function doSync() {
    if (syncing) return;
    if (Date.now() - lastSyncedAt < 1000) return;
    syncing = true;
    try {
      const cart = await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
      // Cookie is the only source of truth for ADDING gifts. cart.discount_codes
      // is also tracked so we don't auto-remove gifts when the cookie expires
      // but the code is still applied to the cart.
      const cookieCode = getDiscountCookieCode();
      const codesToAdd = cookieCode ? [cookieCode] : [];
      const codesToKeep = new Set(codesToAdd);
      (cart.discount_codes || []).forEach((d) => {
        if (d.applicable) codesToKeep.add(String(d.code).toUpperCase());
      });

      const autoAdded = (cart.items || []).filter(
        (i) => i.properties && i.properties._coupon_gift
      );

      let changed = false;

      const allGiftItems = (cart.items || []).filter(
        (i) => i.properties && (i.properties._coupon_gift || i.properties._threshold_gift)
      );
      const paidItems = (cart.items || []).filter(
        (i) => !(i.properties && (i.properties._coupon_gift || i.properties._threshold_gift))
      );
      // No paid items in cart: never auto-add gifts. If there are stale gifts, remove them.
      if (paidItems.length === 0) {
        if (allGiftItems.length > 0) {
          for (const g of allGiftItems) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "same-origin",
              body: JSON.stringify({ id: g.key, quantity: 0 }),
            });
          }
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", { bubbles: true })
          );
        }
        lastSyncedAt = Date.now();
        syncing = false;
        return;
      }

      for (const item of autoAdded) {
        const itemCode = String(item.properties._coupon_gift).toUpperCase();
        // Only remove if the code is no longer applied anywhere (no cookie + not in cart)
        if (!codesToKeep.has(itemCode)) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
          changed = true;
        }
      }

      for (const code of codesToAdd) {
        const products = mapping[code];
        if (!products) continue;

        // Per-variant dedup: only add variants not already in cart for this code
        const productsToAdd = products.filter(
          (p) =>
            !autoAdded.some(
              (i) =>
                String(i.properties._coupon_gift || "").toUpperCase() === code &&
                String(i.variant_id) === String(p.id)
            )
        );

        // Skip variants already in the cart as a threshold gift to avoid duplicates
        const itemsToAdd = productsToAdd.filter(
          (p) =>
            !(cart.items || []).some(
              (i) =>
                i.properties &&
                i.properties._threshold_gift &&
                String(i.variant_id) === String(p.id)
            )
        );
        if (!itemsToAdd.length) continue;

        // Add each item independently so one bad variant doesn't block the others
        for (const p of itemsToAdd) {
          try {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "same-origin",
              body: JSON.stringify({
                id: p.id,
                quantity: p.qty,
                properties: { _coupon_gift: code },
              }),
            });
            if (!res.ok) {
              console.warn(
                "[coupon-gifts] add rejected",
                code,
                "variant",
                p.id,
                res.status
              );
              continue;
            }
            changed = true;
          } catch (err) {
            console.warn(
              "[coupon-gifts] add failed for",
              code,
              "variant",
              p.id,
              err
            );
          }
        }
      }

      if (thresholdEnabled) {
        const cart2 = changed
          ? await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json())
          : cart;

        const realSubtotal = (cart2.items || [])
          .filter(
            (i) =>
              !(
                i.properties &&
                (i.properties._coupon_gift || i.properties._threshold_gift)
              )
          )
          .reduce((sum, i) => sum + i.final_price * i.quantity, 0);

        const thresholdGiftItem = (cart2.items || []).find(
          (i) => i.properties && i.properties._threshold_gift
        );
        // A coupon gift covering the same variant counts as "already gifted",
        // so we don't add a duplicate threshold gift — but we never remove it
        // from the threshold path (it belongs to the coupon).
        const couponGiftCoverage = (cart2.items || []).find(
          (i) =>
            i.properties &&
            i.properties._coupon_gift &&
            String(i.variant_id) === String(thresholdCfg.variantId)
        );
        const hasGiftCoverage = !!(thresholdGiftItem || couponGiftCoverage);

        if (
          thresholdGiftEligible &&
          realSubtotal >= thresholdCfg.amountCents &&
          !hasGiftCoverage
        ) {
          try {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "same-origin",
              body: JSON.stringify({
                id: thresholdCfg.variantId,
                quantity: 1,
                properties: { _threshold_gift: "1" },
              }),
            });
            changed = true;
          } catch (err) {
            console.warn("[threshold-gift] add failed", err);
          }
        } else if (
          thresholdGiftItem &&
          (!thresholdGiftEligible || realSubtotal < thresholdCfg.amountCents)
        ) {
          // Además del carrito que bajó del umbral, esto cubre al cliente que armó el
          // carrito deslogueado y después inició sesión: el regalo ya no le corresponde.
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ id: thresholdGiftItem.key, quantity: 0 }),
          });
          changed = true;
        }
      }

      if (changed) {
        document.dispatchEvent(
          new CustomEvent("theme:cart:reload", { bubbles: true })
        );
      }
    } catch (err) {
      console.warn("[coupon-gifts] sync failed", err);
    } finally {
      lastSyncedAt = Date.now();
      syncing = false;
    }
  }

  function scheduleSync() {
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(doSync, 400);
  }

  let lastCookie = "";
  function pollCookie() {
    const current = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    const val = current ? current[1] : "";
    if (val !== lastCookie) {
      lastCookie = val;
      scheduleSync();
    }
  }
  setInterval(pollCookie, 2000);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) pollCookie();
  });

  document.addEventListener("theme:cart:change", scheduleSync);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleSync);
  } else {
    scheduleSync();
  }
})();

/* ===== Popup frequency (session / day / week) ===== */
(function () {
  const COOKIE_PREFIX = "wou-popup-";

  const readCookie = (name) => {
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="));
    return match ? match.split("=")[1] : null;
  };

  const writeCookie = (name, days) => {
    let expires = "";
    if (days > 0) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + d.toUTCString();
    }
    document.cookie = `${name}=1${expires}; path=/`;
  };

  const init = () => {
    const popups = document.querySelectorAll(
      "[data-promo-text][data-frequency]"
    );
    if (!popups.length) return;

    const designMode = !!(window.Shopify && window.Shopify.designMode);

    popups.forEach((popup) => {
      const frequency = popup.getAttribute("data-frequency");
      const blockId = popup.getAttribute("data-block-id");
      if (!blockId || frequency === "always") return;

      const cookieName = COOKIE_PREFIX + blockId;

      if (!designMode && readCookie(cookieName)) {
        popup.style.display = "none";
        popup.setAttribute("hidden", "");
        return;
      }

      popup.addEventListener("click", (evt) => {
        if (!evt.target.closest("[data-close-modal]")) return;
        const days =
          frequency === "session"
            ? 0
            : frequency === "day"
              ? 1
              : frequency === "week"
                ? 7
                : 0;
        writeCookie(cookieName, days);
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ===== Popup trigger: show when a target section enters the viewport ===== */
(function () {
  function showPopup(popup) {
    var inner = popup.querySelector(".popup__inner");
    if (inner) {
      inner.style.display = "block";
    }
    var overlay = popup.querySelector(".popup__overlay");
    if (overlay) {
      overlay.style.display = "";
      overlay.style.opacity = "";
    }
  }

  function hideOverlay(popup) {
    var overlay = popup.querySelector(".popup__overlay");
    if (!overlay) return;
    overlay.style.display = "none";
    overlay.style.opacity = "0";
  }

  function hidePopup(popup) {
    var inner = popup.querySelector(".popup__inner");
    if (inner) inner.style.display = "none";
    hideOverlay(popup);
  }

  function bindClose(popup) {
    popup.addEventListener("click", function (e) {
      if (!e.target.closest("[data-close-modal]")) return;
      e.preventDefault();
      hidePopup(popup);
    });
  }

  function init() {
    var popups = document.querySelectorAll(
      '[data-promo-text][data-popup-delay="section"][data-popup-section]'
    );
    if (!popups.length || !("IntersectionObserver" in window)) return;

    popups.forEach(function (popup) {
      // Respect the frequency cookie: the earlier handler hides the popup
      // if the user already saw and dismissed it recently.
      if (popup.hidden || popup.style.display === "none") return;

      // Hide the overlay upfront so the page isn't darkened while waiting
      // for the trigger — and stays un-darkened even if the configured
      // selector is invalid or doesn't match anything.
      hideOverlay(popup);

      // Bind our own close handler. theme.js only registers its close
      // handler when its internal cookie is absent, so when we bypass
      // that cookie to show the popup, we also need to own the close.
      bindClose(popup);

      var selector = popup.getAttribute("data-popup-section");
      if (!selector) return;

      var target;
      try {
        target = document.querySelector(selector);
      } catch (e) {
        return;
      }
      if (!target) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              showPopup(popup);
              observer.disconnect();
            }
          });
        },
        // Fire when the target's top edge crosses the upper third of the
        // viewport — i.e. the user has scrolled enough that the section
        // title sits near the top of the screen.
        { threshold: 0, rootMargin: "0px 0px -70% 0px" }
      );

      observer.observe(target);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

class CartClearButton extends HTMLElement {
  constructor() {
    super();
    this.modalId = null;
    this.modal = null;
    this.confirmBtn = null;
    this.closeBtns = [];
    this.trigger = null;
    this.busy = false;
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
  }

  connectedCallback() {
    this.modalId = this.getAttribute("data-modal-id");
    if (!this.modalId) return;
    this.modal = document.getElementById(this.modalId);
    if (!this.modal) return;
    this.confirmBtn = this.modal.querySelector("[data-cart-clear-confirm]");
    this.closeBtns = Array.from(this.modal.querySelectorAll("[data-cart-clear-close]"));
    this.trigger = this.querySelector("button");
    if (!this.trigger || !this.confirmBtn) return;

    this.trigger.addEventListener("click", this.handleTriggerClick);
    this.confirmBtn.addEventListener("click", this.handleConfirm);
    this.closeBtns.forEach((b) => b.addEventListener("click", this.handleClose));
    this.modal.addEventListener("click", this.handleBackdropClick);
  }

  disconnectedCallback() {
    if (this.trigger) this.trigger.removeEventListener("click", this.handleTriggerClick);
    if (this.confirmBtn) this.confirmBtn.removeEventListener("click", this.handleConfirm);
    this.closeBtns.forEach((b) => b.removeEventListener("click", this.handleClose));
    if (this.modal) this.modal.removeEventListener("click", this.handleBackdropClick);
  }

  openModal() {
    if (typeof this.modal.showModal === "function") {
      this.modal.showModal();
    } else {
      this.modal.setAttribute("open", "");
    }
  }

  closeModal() {
    if (typeof this.modal.close === "function") {
      this.modal.close();
    } else {
      this.modal.removeAttribute("open");
    }
  }

  handleTriggerClick(event) {
    event.preventDefault();
    this.openModal();
  }

  handleClose(event) {
    event.preventDefault();
    this.closeModal();
  }

  handleBackdropClick(event) {
    if (event.target === this.modal) this.closeModal();
  }

  handleConfirm(event) {
    event.preventDefault();
    if (this.busy) return;
    this.busy = true;
    this.confirmBtn.disabled = true;

    const ajaxDisabled = !!document.querySelector('[data-ajax-disable="true"]');
    const cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) || "/cart";

    fetch(`${cartRoute}/clear.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error("clear failed");
        return response.json();
      })
      .then((cart) => {
        this.closeModal();
        if (ajaxDisabled) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", { detail: { cart }, bubbles: true })
        );
        document.dispatchEvent(
          new CustomEvent("theme:cart:reload", { bubbles: true })
        );
      })
      .catch((err) => {
        console.error("[cart-clear]", err);
      })
      .finally(() => {
        this.busy = false;
        if (this.confirmBtn) this.confirmBtn.disabled = false;
      });
  }
}
if (!customElements.get("cart-clear-button")) {
  customElements.define("cart-clear-button", CartClearButton);
}
